<template>
  <div id="InitiaExpert" v-loading="loading" element-loading-text="拼命加载中">
    <h3>评价说明：</h3>
    <div class="instructions">
      <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;评分时，企业现状（结果）建议如下：</p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、较差：0—5分 企业未建有设备管理体系； 企业设备管理制度不能涵盖设备一生管理； 企业未建立设备管理评价指标； 企业设备管理处于事后维修状态；
      </p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、一般：5—10分 企业设备管理体系不健全； 企业设备管理制度缺乏闭环管理，流于形式； 企业建立的设备经济运行指标不能有效促进企业设备管理；
        企业设备缺乏有效的预防性维护；
      </p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3、良好：10—15分 企业有完整的设备管理体系及制度健全； 企业设备经济运行指标且能够指导企业设备管理的改进； 企业全面开展“5S”、“TPM”、管理；
        企业应用信息化设备管理平台，设备预防性维护基本形成闭环管理；
      </p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4、较好：15—20分 企业在开展“5S”、“TPM”管理的基础上，全面推进精益管理； 企业已经形成以“自主保全”和“计划保全”体系；
        企业各项经济技术指标具备业内竞争实力； 企业已经实现关键设备的数字化、信息化管理； 企业预防性维护资金占总维修费用支出的70%以上；
      </p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5、很好：20—25分 企业全面实现精益管理，经济效益业绩等在行业领先； 企业主要生产设备全面实现数字化、信息化管理；
        企业设备重复性故障发生率为“零”； 企业基本实现设备“零故障”;
      </p>
    </div>
    <h3>专家评分：</h3>
    <div class="selfBoxs">
      <initiaItem style="padding-right: 10px; flex: 1" :data="examinationInfo.questionBankList"></initiaItem>
      <div class="catalogue"></div>
      <div class="catalogue" style="position: fixed; right: 20px; top: 100px">
        <h3 style="width: 100%; margin-bottom: 10px">目录</h3>
        <h3 style="width: 100%; margin-bottom: 10px">总分数：{{ totalScore }}</h3>
        <div @click="handleCatalog(item)" :class="item.class" class="box nowrap" v-for="(item, index) in catalogue" :key="`${index}a1`">{{ item.index }}{{ item.name }}</div>
      </div>
    </div>
    <div class="expertSignature">
      <!-- <h3>专家签名</h3>
      <div v-if="!signature" class="boxSig" @click="handleSignDialog"></div>
      <img v-else class="imgSig" @click="handleSignDialog" :src="signature" alt="" />
      <div class="TextSig blue" @click="handleReceiverSign('', 1)">使用已保存的电子签名</div> -->
    </div>
    <div class="btnGurop">
      <el-button @click="common.returnBtn"><i class="el-icon-arrow-left"></i></el-button>
      <el-button :loading="btnLoading" type="primary" @click="successAve">{{ isChiefReviewer == 1 ? '填写主评' : '提 交' }}</el-button>
      <el-button :loading="btnLoading" @click="httpsSave(1, true)">暂 存</el-button>
    </div>
    <!-- 签名 -->
    <sign-dialog ref="signDialog" @change="handleReceiverSign"></sign-dialog>
    <!-- 主评审填写信息 -->
    <el-dialog title="主审专家点评" :visible.sync="dialogFormVisible">
      <el-form @submit.native.prevent :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="主审专家点评" prop="expertOpinion">
          <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="form.expertOpinion"> </el-input>
        </el-form-item>
        <el-form-item label="佐证图片">
          <div class="suppBox">
            <div @click="handleViewer(form, todex)" class="suppPicture" v-for="(pic, todex) in form.expertPicture" :key="`${todex}a`">
              <img :src="pic" alt="" />
              <i @click.stop="handleDelPic(pic, form)" class="picDel el-icon-error"></i>
            </div>
            <el-upload accept="image/*" class="avatar-uploader suppPicture" :action="uploadUrl" :show-file-list="false" :http-request="(fileObj) => uploadImg(fileObj, form)">
              <div class="avatar" type="primary">+</div>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">提 交</el-button>
      </div>
    </el-dialog>
    <!-- 上传图片截图工具 -->
    <cropper ref="myCroppr" @emitt="callBack"></cropper>

    <FloatingButton @change="onBtnClicked">
      <span slot="text" class="green">
        <span style="font-weight: 600">{{ catalogue.filter((item) => item.class).length }}</span
        >/<span class="blue">{{ catalogue.length }}</span>
      </span>
    </FloatingButton>
    <el-drawer size="80%" title="目录" :visible.sync="drawer" direction="rtl">
      <h3 style="width: 100%; margin: 0 0 10px 20px">总分数：{{ totalScore }}</h3>
      <div class="catalodfet">
        <div @click="handleCatalog(item)" :class="item.class" class="box" v-for="(item, index) in catalogue" :key="`${index}a1`">{{ item.index }}{{ item.name }}</div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import moment from 'moment';
import initiaItem from './InitiaExperttem/initia_Item.vue';
import signDialog from '../../components/sin-canvas.vue';
import cropper from '../../components/cropper.vue';
export default {
  name: 'InitiaExpert',
  components: { initiaItem, signDialog, cropper },
  data() {
    return {
      examinationInfo: {},
      receiverSignFlag: true,
      expertId: this.$route.query.expertId, // 自评 id
      selfId: this.$route.query.selfId,
      loading: true,
      btnLoading: false,
      signature: '', // 签名 url
      isChiefReviewer: '', // 是否是主评审
      dialogFormVisible: false,
      uploadUrl: `${process.env.BASE_URL}api/file/upload`,
      form: {
        expertOpinion: '',
        expertPicture: [],
      },
      rules: {
        expertOpinion: [{ required: true, message: '请输入主审专家点评', trigger: 'blur' }],
      },
      intervalId: null, // 自动保存
      catalogue: [],
      totalScore: 0,
      drawer: false,
      defaultExpansion: [], // 默认折叠展开的id
    };
  },
  watch: {
    examinationInfo: {
      handler(newVal, oldVal) {
        this.catalogue = [];
        this.filterByTier(newVal.questionBankList);
        console.log('🚀 ~ this.catalogue :', this.catalogue);
      },
      deep: true,
    },
  },
  created() {
    this.getExaminationInfo();
    this.getChiefReviewerInfo();
    this.getSignature();
  },
  mounted() {},
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
  },
  methods: {
    moment,
    // 获取详情回显内容
    getExaminationInfo() {
      this.$axios.post('api/review/expertInfo', { expertId: this.expertId }).then((res) => {
        if (res.data.code == 200) {
          this.loading = false;
          this.examinationInfo = res.data.data;
          this.isChiefReviewer = res.data.isChiefReviewer;
          /**
           * 将 里面的 图片字符串转成数组
           */
          this.filterData(this.examinationInfo.questionBankList, true);
          this.catalogue = [];
          this.filterByTier(this.examinationInfo.questionBankList);
          this.recursionFun(this.examinationInfo.questionBankList);

          this.intervalId = setInterval(() => {
            console.log('🚀 ~ 自动保存中！！！:');
            let pandms = JSON.parse(JSON.stringify(this.examinationInfo));
            this.filterData(pandms.questionBankList, false);
            this.$axios.post(`api/review/startReview?status=1`, pandms);
          }, 60000);
        }
      });
    },
    // 获取详情回显内容
    getSignature() {
      this.$axios.post('api/review/getSignature', { selfId: this.selfId }).then((res) => {
        if (res.data.code == 200) {
          this.signature = res.data.signature;
        }
      });
    },

    successAve() {
      const cataNum1 = this.catalogue.filter((item) => item.class).length;
      console.log('🚀 ~ 已答题数量:', cataNum1);
      console.log('🚀 ~ 总数量:', this.catalogue.length);
      // if (cataNum1 != this.catalogue.length) {
      //   this.$message({
      //     type: 'info',
      //     message: '请填写完成答题',
      //   });
      //   return;
      // }
      // 1、先判断有无签名
      // if (!this.signature) {
      //   this.$message({
      //     type: 'info',
      //     message: '请填写签名',
      //   });
      //   return;
      // }
      // 2、判断是否为 主评审，是的话 弹出主评审的 填写框 1 主评审 2 不是
      if (this.isChiefReviewer == 1) {
        this.dialogFormVisible = true;
        setTimeout(() => {
          this.BoxLayout();
        }, 100);
        return;
      } else {
        this.httpsSave(1);
      }
    },
    // 提交之前需要签名：
    handleSignDialog() {
      this.$refs.signDialog.visible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$set(this.form, 'selfId', this.selfId);
          let pandms = JSON.parse(JSON.stringify(this.form));
          pandms.selfId = Number(pandms.selfId);
          pandms.expertPicture = pandms.expertPicture ? pandms.expertPicture.join(',') : '';
          this.$axios.post('api/review/chiefReviewer', pandms).then((res) => {
            if (res.data.code == 200) {
              this.httpsSave(1);
              this.dialogFormVisible = false;
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 获取 主评审详情
    getChiefReviewerInfo() {
      this.$axios.post('api/review/chiefReviewerInfo', { selfId: this.selfId }).then((res) => {
        if (res.data.code == 200) {
          this.form.expertOpinion = res.data.expertOpinion;
          this.form.expertPicture = res.data.expertPicture ? res.data.expertPicture.split(',') : [];
        }
      });
    },

    // 签名成功返回
    handleReceiverSign(val, status) {
      this.$axios.post('api/review/submit', { selfId: this.selfId, signature: val, status }).then((res) => {
        if (res.data.code == 200) {
          if (status == 1) {
            const sigImg = JSON.parse(res.data.signature);
            this.signature = sigImg[0].url;
          } else {
            this.signature = val;
          }
        } else {
          this.btnLoading = false;
          this.$message({
            message: `签名上传失败${res.data.msg}`,
            type: 'error',
            offset: 80,
          });
        }
      });
    },
    /**
     * 专家提交的逻辑大概是：
     * 1、先判断有无签名 this.signature
     * 2、填写主评审
     * 3、发起提交请求
     */
    // 保存 请求
    httpsSave(status, save) {
      /**
       * copy 一份，避免影响原有数据
       * 将 里面的 图片数组转成字符串
       */
      this.btnLoading = true;
      let pandms = JSON.parse(JSON.stringify(this.examinationInfo));
      // console.log('🚀 ~ pandms:', pandms);
      this.filterData(pandms.questionBankList, false);
      this.$axios.post(`api/review/startReview?status=${status}`, pandms).then((res) => {
        if (res.data.code == 200) {
          this.btnLoading = false;
          clearInterval(this.intervalId);
          if (save) {
            this.common.returnBtn();
            return;
          }
          this.$router.push({
            path: '/Preview',
            query: { expertId: this.expertId, selfId: this.selfId },
          });
        } else {
          clearInterval(this.intervalId);
          this.btnLoading = false;
          this.$message({
            message: `${status == 1 ? '暂存' : '提交'}失败${res.data.msg}`,
            type: 'error',
            offset: 80,
          });
        }
      });
    },
    filterData(data, type) {
      if (data && data.length) {
        try {
          data.forEach((e) => {
            if (type) {
              e.expertPicture = e.expertPicture ? e.expertPicture.split(',') : [];
              e.picture = e.picture ? e.picture.split(',') : [];
            } else {
              e.expertPicture = e.expertPicture ? e.expertPicture.join(',') : '';
              e.picture = e.picture ? e.picture.join(',') : '';
            }
            this.filterData(e.questionBankList, type);
          });
        } catch (error) {
          this.btnLoading = false;
          this.$message({
            message: `提交失败'`,
            type: 'error',
            offset: 80,
          });
        }
      }
    },
    onBtnClicked() {
      this.drawer = true;
    },

    /** 佐证图片处理 */
    uploadImg(fileObj, item) {
      this.$refs.myCroppr.changeUpload(fileObj, item);
    },
    BoxLayout() {
      this.$nextTick(() => {
        let lists = document.querySelectorAll('.suppBox');
        if (lists && lists.length) {
          lists.forEach((lis) => {
            const boxLay = new this.DynamicBoxLayout(lis, '.suppPicture', 80);
            boxLay.boxes.forEach((box) => {
              if (box) {
                box.style.height = box.style.width;
              }
            });
          });
        }
      });
    },
    // 图标上传回调
    callBack(data) {
      data.type.expertPicture.push(data.url);
      this.$message({ message: `上传成功`, type: 'success' });
      setTimeout(() => {
        this.BoxLayout();
      }, 100);
    },
    // 删除佐证图片
    handleDelPic(pic, item) {
      this.$confirm('此操作将永久删除该图片, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$axios.post('api/file/deleteFileByUrl', { fileUrl: pic }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: `删除成功`,
                type: 'success',
                offset: 80,
              });
              const index = item.expertPicture.indexOf(pic);
              if (index > -1) {
                item.expertPicture.splice(index, 1);
              }
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
                offset: 80,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    // 查看佐证图片
    handleViewer(item, key) {
      this.$viewerApi({
        images: item.expertPicture,
        options: {
          initialViewIndex: key,
        },
      });
    },

    handleCatalog(item) {
      console.log('🚀 ~ item:', item.index);
      this.handDfaultFold(item.index);
      this.$nextTick(() => {
        let element = document.getElementById(`title${item.index}`);
        element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      });
    },
    // 计算 序号
    filterByTier(data) {
      // console.log('🚀 ~ data:', data);
      let that = this;
      function traverse(arr, parentIndex) {
        arr.forEach((obj, index) => {
          let currentIndex = '';
          if (obj.tier == 4) {
            if (obj.expertScore > 0) {
              that.$set(obj, 'class', 'complets');
            }
            that.catalogue.push(obj);
          }
          currentIndex = parentIndex ? `${parentIndex}.${index + 1}` : `${index + 1}`;
          that.$set(obj, 'index', currentIndex);
          // 默认展开第一层
          if (obj.tier == 2) {
            that.defaultExpansion.push(obj.id);
          }
          if (obj.questionBankList) {
            traverse(obj.questionBankList, currentIndex);
          }
        });
      }
      traverse(data);

      let sum = 0;
      this.catalogue.forEach((item) => {
        sum += item.expertScore ? Number(item.expertScore) : 0;
      });
      this.totalScore = sum;
    },
    handDfaultFold(index) {
      diguiFold(this, this.examinationInfo.questionBankList);
      function diguiFold(that, arr) {
        if (arr && arr.length) {
          arr.forEach((e) => {
            that.$set(e, 'isFold', false);
            diguiFold(that, e.questionBankList);
          });
        }
      }
    },
    recursionFun(arr) {
      if (arr && arr.length) {
        arr.forEach((e) => {
          if (this.defaultExpansion.includes(e.id)) {
            this.$set(e, 'isFold', false);
          } else {
            this.$set(e, 'isFold', true);
          }
          this.recursionFun(e.questionBankList);
        });
      }
    },
  },
  beforeDestroy() {
    // 清除定时器
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
};
</script>

<style lang="less" scoped>
#InitiaExpert {
  padding-bottom: 0 !important;
}
.expertSignature {
  margin: 20px 0 70px 0;
  .boxSig,
  .imgSig {
    margin: 10px;
    width: 220px;
    height: 80px;
    cursor: pointer;
    border-radius: 4px;
    background-color: rgba(249, 249, 249, 1);
    border: 1px solid rgba(187, 187, 187, 1);
  }
  // .imgSig{

  // }
  .TextSig {
    font-size: 14px;
    margin: 10px;
    cursor: pointer;
  }
}
.btnGurop {
  // width: auto;
  bottom: 0;
  position: fixed;
  display: flex;
  height: 50px;
  align-items: center;
  background-color: #fff;
}
.suppBox {
  display: flex;
  flex-wrap: wrap;
  .suppPicture {
    margin: 0 10px 10px 0;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .picDel {
      position: absolute;
      right: 4px;
      top: 4px;
      font-size: 22px;
      color: rgba(255, 0, 0, 0.735);
      cursor: pointer;
    }
  }
}
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin: 0 10px 10px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1 / 1;
  /deep/ .el-upload {
    width: 100%;
    height: 100%;
  }
  .avatar {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    display: block;
    font-size: 38px;
    color: #d9d9d9;
  }
}
.selfBoxs {
  display: flex;
  .catalogue {
    width: 280px;
    min-width: 280px;
    max-width: 280px;
    padding-left: 10px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    max-height: 85%;
    overflow: auto;
    overflow-x: hidden;
    .box {
      cursor: pointer;
      width: 85%;
      height: 30px;
      font-size: 14px;
      border: 1px solid #ccc;
      margin: 0 8px 8px 0;
      display: flex;
      justify-content: left;
      align-items: center;
      padding: 0px 5px;
    }
    .complets {
      border: 1px solid #015d14;
      background-color: #198e3027;
    }
  }
}
.catalodfet {
  padding-left: 10px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  .box {
    cursor: pointer;
    width: fit-content;
    height: 30px;
    font-size: 14px;
    border: 1px solid #ccc;
    margin: 0 8px 8px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 5px;
  }
  .complets {
    border: 1px solid #015d14;
    background-color: #198e3027;
  }
}
.instructions {
  line-height: 30px;
  margin-bottom: 20px;
  margin-right: 280px;
}
</style>

<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
  /deep/.el-dialog {
    width: 80%;
  }
  .catalogue {
    display: none !important;
  }
  .instructions {
    margin-right: 0px !important;
  }
}
</style>
